'use strict';

/*@ngInject*/
module.exports = function ($rootScope,$scope, $state, $location, $modal, $anchorScroll, $window, platform, $translate, urlFormats) {
    $scope.downloadColPopup = true;
    $scope.headerPopup = true;

    $scope.platform = platform;
    $scope.currentPlatform = $scope.platform.os.family.toLowerCase();
    $scope.currentState = $state;
    $scope.$watch('currentState.current.name', function (newValue, oldValue) {
        if (newValue) {
            if (newValue.toLowerCase() === 'home') {
                $scope.isHomePage = true;
                $scope.isButtonFloating = true;
            }
            else {
                $scope.isHomePage = false;
                $scope.isButtonFloating = false;
            }

            if (newValue.toLowerCase() !== 'home') {
                $scope.isButtonFloating = true;
            }
            // if (newValue.toLowerCase() === 'support' || newValue.toLowerCase() === 'featurevideo') {
            //  $scope.isButtonFloating = true;
            // }
        }

    });

    if ($location.search().data) {
        $scope.androidDownloadLink = urlFormats.android.googlePlay + $location.search().data;
        $scope.iosDownloadLink = urlFormats.ios.appStore + $location.search().data;
        $scope.windowDownloadLink = urlFormats.windows.windowsStore+ "?name=SafeFamilySetup_"  + $location.search().data+".exe";
        $rootScope.searchData = $location.search().data;
    } else {
        $scope.androidDownloadLink = urlFormats.android.googleDefault;
        $scope.iosDownloadLink = urlFormats.ios.appstoreDefault;
        $scope.windowDownloadLink = urlFormats.windows.windowsDefault;
    }

    
    $scope.gaFunction = function(labelValue){
        console.log("Called Header Controller");
        //window.ga('send', 'event','Onboarding', 'Windows Download - Landing page',labelValue,'download_landing_page', 'Lifecycle');
        /*window.ga('send', 'event', {
            eventCategory: 'Onboarding',
            eventAction: 'Windows Download - Landing page',
            eventLabel: labelValue,
            'dimension1': 'download_landing_page',
            'dimension2': 'Lifecycle',
            'dimension6': 'true',//interative
            'dimension4': 'true'//userinitiated
        });*/
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Onboarding")
            .action('Windows Download - Landing page')
            .label(labelValue)
            .interactive(true)
            .userInitiated(true)
            .finish();
          $location.path('/redirect');
        //Open URL is hardcoded over here to prod url for downloading windows build
        // and redirecting the user windows page to begin downloading
       // window.open($scope.windowDownloadLink, '_self', 'location=yes');

    };
    $scope.toggleDownloadColPopup = function () {
        $scope.downloadColPopup = !$scope.downloadColPopup;
        // mouseover event, get current element position, reset the downloadpopup
    };


    $scope.toggleDownloadColPopup = function () {
        $scope.downloadColPopup = !$scope.downloadColPopup;
        // mouseover event, get current element position, reset the downloadpopup


    };

    // fix-09-01-2015
    // if (platform.os && platform.os.family) {
    //  $scope.isWindows = platform.os.family.toLowerCase().indexOf('win') >= 0;
    // }

    $scope.onScroll = function (isTop) {
        if ($scope.isHomePage) {
            if ($scope.isButtonFloating === isTop) {
                $scope.isButtonFloating = !isTop;
                $scope.$apply();
            }
        }
    };
    $scope.toggleMenu = function ($event) {
        $scope.isMenuClose = !$scope.isMenuClose;

        // $event.preventDefault();
        $event.stopPropagation();
    };

    $scope.closeMenuIfOpen = function ($event) {
        if (!$scope.isMenuClose) {
            $scope.isMenuClose = true;
        }
    };

    $scope.anchorClick = function () {
        $anchorScroll();
    };

    $scope.showDownloadModal = function ($event) {
        $event.preventDefault();

        $modal.open({
            templateUrl: 'views/_download.html'
            //fix-09-01-2015
            //controller: 'downloadController'
            // 9-1-2015: remove auto-download of windows setup file
            // })
            // .opened.then(function() {
            //  var href = $event.target.getAttribute('href');
            //  if (href) {
            //      $window.location.href = href;
            //  }
        });
    };


    $scope.downloadPopup = true;

    $scope.redirectToDownload = function(){
        //window.location.href = '/redirect';
        $location.path('/download');
    };

    $scope.toggleDownloadPopup = function ($event) {

        $scope.downloadPopup = !$scope.downloadPopup;

        if (!$scope.downloadPopup) {
            var angular = require('angular');
            var winwidth = angular.element(document.getElementById("header-sticky")).width();  //somehow the headerpopup width is 0

            var rect = document.getElementById('headerfree').getBoundingClientRect();

            var popwidth = 620;
            var popheight = 200;

            if (winwidth <= 480) {
                popwidth = 250;
                popheight = 320;
            }


            var top = 0;
            if (rect.left < 480) {
                var left = Number(winwidth - popwidth) / 2 + 'px';
                $scope.topleft = { 'left': left, 'top': top };
            } else {
                var right = Number(winwidth - rect.right) + 'px';

                $scope.topleft = { 'right': right, 'top': top };
            }


        }


        $event.stopPropagation();
    };


    $scope.closeDownloadPopup = function () {

        $scope.downloadPopup = true;

    };


};